import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import styles from './styles'

const Toolbar = props => (
  <nav className={cx(styles.wrapper, props.className)}>
    <div className={styles.left}>{props.left}</div>
    {props.right && <div className={styles.right}>{props.right}</div>}
  </nav>
)

Toolbar.propTypes = {
  className: PropTypes.string,
  left: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  ]).isRequired,
  right: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  ]),
}

export default Toolbar
